import { createFileRoute } from '@tanstack/react-router';
import { InstantApplyPage } from '@/components/ApplyPage/InstantApplyPage';
import { SessionNotAvailable } from '@/components/SessionNotAvailable';
import { loadPublicTemplate } from '@/lib/loadPublicTemplate';

export const Route = createFileRoute('/apply/$publicId/instant')({
  component: InstantApplyPageComponent,
  loader: async ({ params }) => {
    return loadPublicTemplate(params.publicId);
  },
});

function InstantApplyPageComponent() {
  const { vacancy, unavailableReason } = Route.useLoaderData();

  if (!vacancy) {
    return <SessionNotAvailable reason={unavailableReason} />;
  }

  return <InstantApplyPage vacancy={vacancy} />;
}
